import React from 'react';
import { Check, X } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="bg-gray-50 py-10 md:py-14 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-3">
          🧠 La transformación
        </h2>

        <div className="grid grid-cols-2 gap-3" data-id="element-4">
          {/* Before */}
          <div className="bg-red-50 p-4 md:p-6 rounded-xl border border-red-100" data-id="element-5">
            <h3 className="text-sm md:text-lg font-bold text-red-700 mb-4 text-center uppercase" data-id="element-6">
              Antes
            </h3>
            <ul className="space-y-3" data-id="element-7">
              {['"No quiero estudiar"', 'Se distrae fácilmente', 'Prefiere pantallas'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-8">
                  <X className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-9" />
                  <span className="text-sm text-gray-700" data-id="element-10">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-green-50 p-4 md:p-6 rounded-xl border border-green-200 shadow-lg" data-id="element-11">
            <h3 className="text-sm md:text-lg font-bold text-green-700 mb-4 text-center uppercase" data-id="element-12">
              Después
            </h3>
            <ul className="space-y-3" data-id="element-13">
              {['"¡Mamá mira esto!"', 'Aprende jugando', 'Curiosidad activa todos los días'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-14">
                  <div className="bg-green-500 rounded-full p-0.5 flex-shrink-0 mt-0.5" data-id="element-15">
                    <Check className="w-3 h-3 text-white" data-id="element-16" />
                  </div>
                  <span className="text-sm text-gray-800 font-semibold" data-id="element-17">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center mt-6 text-base font-bold text-gray-900" data-id="element-18">
          👉 Eso es lo que realmente estás comprando.
        </p>
      </div>
    </section>;
}